import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  warningColorLight,
  primaryColorLight,
  dangerColorLight,
  successColorLight,
  infoColorLight,
  roseColorLight,
  grayColorLight,
  defaultFont
} from "assets/jss/material-dashboard-react.jsx";

const tableStyle = theme => ({
  warningTableHeader: {
    color: warningColor
  },
  primaryTableHeader: {
    color: primaryColor
  },
  dangerTableHeader: {
    color: dangerColor
  },
  successTableHeader: {
    color: successColor
  },
  infoTableHeader: {
    color: infoColor
  },
  roseTableHeader: {
    color: roseColor
  },
  grayTableHeader: {
    color: grayColor
  },
  warningRowColor: {
    backgroundColor: warningColorLight
  },
  primaryRowColor: {
    backgroundColor: primaryColorLight
  },
  dangerRowColor: {
    backgroundColor: dangerColorLight
  },
  successRowColor: {
    backgroundColor: successColorLight
  },
  infoRowColor: {
    backgroundColor: infoColorLight
  },
  roseRowColor: {
    backgroundColor: roseColorLight
  },
  grayRowColor: {
    backgroundColor: grayColorLight
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse"
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    fontSize: "1em"
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "8px 8px",
    verticalAlign: "middle",
  },
  tableResponsive: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  }
});

export default tableStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/components/tableStyle.jsx